import { Type } from '../objects/Type'
import { getRelation } from './getRelation'
import {personalities} from '../../..//data/socionics/data/types'
function typeRelationsCalculator() {
    let person;
    let person2;
    let scores = [];
    for (let i = 0; i < personalities.length; i++) {
        for (let j = 0; j < personalities.length; j++) {
            person = new Type(personalities[i])
            person2 = new Type(personalities[j])
            scores.push(getRelation(person, person2))
        }
    }
    return (scores)
}
export { typeRelationsCalculator }
